import "css/events.sass";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

import markerShadow from "leaflet/dist/images/marker-shadow.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerIconRetina from "leaflet/dist/images/marker-icon-2x.png";

import "addthisbuttons.js";

// Display maps in OpenStreetMap with Leaflet
(() => {
  const i18n = window.i18n;
  const mapDiv = document.querySelector("#map");

  if (mapDiv) {
    const latitude = mapDiv.getAttribute("data-latitude");
    const longitude = mapDiv.getAttribute("data-longitude");
    const zoom = mapDiv.getAttribute("data-zoom");

    const map = L.map("map").setView([latitude, longitude], zoom);

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: i18n.gettext(
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      ),
      // Referrer policy is required: https://wiki.openstreetmap.org/wiki/Referer
      referrerPolicy: "strict-origin-when-cross-origin",
    }).addTo(map);

    delete L.Icon.Default.prototype._getIconUrl;
    L.Icon.Default.mergeOptions({
      iconRetinaUrl: markerIconRetina,
      iconUrl: markerIcon,
      shadowUrl: markerShadow,
    });

    L.marker([latitude, longitude]).addTo(map).openPopup();
  }
})();
